module.exports = __webpack_public_path__ + "static/media/4.ac40c268.png";